import { Service, ServiceField } from '@onlog-public/additional-services-types';
import { VerticalTableTemplateStore } from '@pages/AdditionalServices/components/Service/VerticalTableTemplate/types';
import {
  ServiceStateGenerator,
  serviceStateGeneratorProcessor,
} from '@pages/AdditionalServices/containers/services/serviceStateGenerator/types';

/**
 * BaseServiceStateGenerator реализует сервис базовой генерации стейтов услуг
 */
export class BaseServiceStateGenerator implements ServiceStateGenerator {
  protected processors: serviceStateGeneratorProcessor[];

  /**
   * Конструктор сервиса
   * @param processors
   */
  constructor(processors: serviceStateGeneratorProcessor[]) {
    this.processors = processors;
  }

  /**
   * Generate выполняет генерацию изначального стейта для шаблонов на
   * основе переданных полей и услуг.
   * @param services
   * @param globalFields
   * @param globalFieldValues
   * @param variantFields
   * @param variantFieldValues
   * @param _
   */
  Generate(
    services: { [x: string]: Service[] },
    globalFields: ServiceField[],
    globalFieldValues: { [x: string]: number },
    variantFields: { [x: string]: ServiceField[] },
    variantFieldValues: { [x: string]: { [x: string]: number } },
    _?: { [x: string]: any }
  ): { [x: string]: { [x: string]: any } } {
    const result: { [x: string]: { [x: string]: any } } = {};

    Object.keys(services).map((variantID) => {
      result[variantID] = {};
      const fields = [...globalFields, ...variantFields[variantID]];
      const values = { ...globalFieldValues, ...variantFieldValues[variantID] };

      services[variantID].map((service) => {
        result[variantID][service.id] = this.generateForService(service, fields, values);
      });
    });

    return result;
  }

  /**
   * Restore выполняет генерацию изначального стейта для шаблонов на
   * основе переданных полям, услуге и восстановленому стейту.
   * @param services
   * @param globalFields
   * @param globalFieldValues
   * @param variantFields
   * @param variantFieldValues
   * @param existStore
   */
  Restore(
    services: { [x: string]: Service[] },
    globalFields: ServiceField[],
    globalFieldValues: { [x: string]: number },
    variantFields: { [x: string]: ServiceField[] },
    variantFieldValues: { [x: string]: { [x: string]: number } },
    existStore?: { [x: string]: any }
  ): { [x: string]: { [x: string]: any } } {
    const result: { [x: string]: { [x: string]: any } } = {};

    Object.keys(services).map((variantID) => {
      result[variantID] = {};
      const fields = [...globalFields, ...variantFields[variantID]];
      const values = { ...globalFieldValues, ...variantFieldValues[variantID] };

      services[variantID].map((service) => {
        result[variantID][service.id] = this.restoreForService(
          service,
          fields,
          values,
          existStore?.[service.id]
        );
      });
    });

    return result;
  }

  /**
   * restoreForService выполняет генерацию стейта по полям и услуге. Возвращает сам стейт.
   * @param service
   * @param fields
   * @param values
   * @param existStore
   */
  protected restoreForService(
    service: Service,
    fields: ServiceField[],
    values: { [T in string]: number },
    existStore?: any
  ): any {
    const processor = this.processors.find((p) => p.isAvailable(service));
    if (!processor) {
      return;
    }

    return processor.restore(service, fields, values, existStore);
  }

  /**
   * generateForService выполняет генерацию стейта по полям и услуге. Возвращает сам стейт.
   * @param service
   * @param fields
   * @param values
   * @param existStore
   */
  protected generateForService(
    service: Service,
    fields: ServiceField[],
    values: { [T in string]: number },
    existStore?: any
  ): any {
    const processor = this.processors.find((p) => p.isAvailable(service));
    if (!processor) {
      return;
    }

    return processor.generate(service, fields, values, existStore);
  }
}
